import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  private matSnackBar = inject(MatSnackBar);

  private readonly SNACKBAR_DURATION: number = 8000;
  private readonly SNACKBAR_HORIZONTAL_POSITION: MatSnackBarHorizontalPosition = "right";
  private readonly SNACKBAR_VERTICAL_POSITION: MatSnackBarVerticalPosition = "top";

  constructor() { }

  // Default SnackBar
  openDefaultSnackBar(message: string) {
    this.matSnackBar.open("🔔\t" + message, "OK", {
      duration: this.SNACKBAR_DURATION,
      horizontalPosition: this.SNACKBAR_HORIZONTAL_POSITION,
      verticalPosition: this.SNACKBAR_VERTICAL_POSITION,
      panelClass: ['default-snackbar']
    });
  }

  // Success SnackBar
  openSuccessSnackBar(message: string) {
    this.matSnackBar.open("🎉\t" + message, "OK", {
      duration: this.SNACKBAR_DURATION,
      horizontalPosition: this.SNACKBAR_HORIZONTAL_POSITION,
      verticalPosition: this.SNACKBAR_VERTICAL_POSITION,
      panelClass: ['success-snackbar']
    });
  }

  // Failure SnackBar
  openFailureSnackBar(message: string) {
    this.matSnackBar.open("⛔\t" + message, "OK", {
      duration: this.SNACKBAR_DURATION,
      horizontalPosition: this.SNACKBAR_HORIZONTAL_POSITION,
      verticalPosition: this.SNACKBAR_VERTICAL_POSITION,
      panelClass: ['failure-snackbar']
    });
  }

  // Warning SnackBar
  openWarningSnackBar(message: string) {
    this.matSnackBar.open("⚠️\t" + message, "OK", {
      duration: this.SNACKBAR_DURATION,
      horizontalPosition: this.SNACKBAR_HORIZONTAL_POSITION,
      verticalPosition: this.SNACKBAR_VERTICAL_POSITION,
      panelClass: ['warning-snackbar']
    });
  }

}
